export const navItems = [
  {
    title: true,
    name: 'Frakcio Superadmin'
  },
  {
    name: 'Condominios',
    url: '/condominios',
    icon: 'fa fa-home'
  },
  {
    name: 'Cortes',
    url: '/cortes',
    icon: 'fa fa-list'
  },
  {
    name: 'Residentes',
    url: '/resident',
    icon: 'fa fa-user'
  },
  {
    name: 'Administradores',
    url: '/admin',
    icon: 'fa fa-user'
  },
  {
    name: 'Usuarios Web Service',
    url: '/usersws',
    icon: 'fa fa-user'
  },
  {
    name: 'Configuración de Pago',
    url: '/paymentconfiguration',
    icon: 'fa fa-credit-card'
  }
];
